import { TEDParseNumberMode } from '../FormatterTypes';
import { TEDCustomNumberDisplayer } from './TEDCustomNumberDisplayer';

class TEDDisplayPercent extends TEDCustomNumberDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDDisplayPercent;

  mode() {
    return TEDParseNumberMode.pnmPercent;
  }
}

export { TEDDisplayPercent };
